import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Tab } from "semantic-ui-react";
import _ from "lodash";
import SearchResultHeader from "./SearchResultHeader";
import HuntingFishingLicenseRecordDetail from "./HuntngFishingRecordDetail";
import { getMenuItem } from "../common/PageHelper";

class HuntingFishingLicenseResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedReportId: null,
    };
  }

  onSelectReport = (selectedReportId) => {
    this.state = { selectedReportId };
  };

  render() {
    const results = [];
    let tabHeader = null;
    if (
      this.props.searchResultData !== undefined &&
      this.props.searchResultData !== null &&
      this.props.searchResultData !== ""
    ) {
      const records = _.get(
        this.props.searchResultData,
        `${
          Object.keys(this.props.searchResultData)[0]
        }.huntFishSearchResponse[0].records[0].record`
      );
      const showNarrowSearchMessage = records && records.length > 25;
      tabHeader = (
        <SearchResultHeader
          showNarrowSearchMessage={showNarrowSearchMessage}
          log={_.get(
            this.props.searchResultData,
            `${Object.keys(this.props.searchResultData)[0]}.log[0]`
          )}
          {...this.props}
          printContent={this.props.printContent}
        />
      );

      if (records !== undefined) {
        _.forEach(records, (record, index) => {
          results.push(
            <Table.Row key={`HuntFish_Body_Table_Row_${index}`}>
              <Table.Cell>
                <HuntingFishingLicenseRecordDetail
                  key={`HuntFish_Body_Table_${index}`}
                  node={record}
                  index={index}
                  {...this.props}
                />
              </Table.Cell>
            </Table.Row>
          );
        });
      }
    }

    const tabs = [];
    const { userAccount } = this.props;
    tabs.push({
      menuItem: getMenuItem(
        userAccount.acctTheme,
        true,
        `${results.length > 0 ? results.length : 0} Matches Found`
      ),
      render: () => (
        <Tab.Pane>
          {tabHeader}
          <Table stackable>
            <Table.Body>{results}</Table.Body>
          </Table>
        </Tab.Pane>
      ),
    });

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(HuntingFishingLicenseResult);



// WEBPACK FOOTER //
// ./src/components/searchresults/HuntingFishingResult.js